export default class en {
	static translations = {
		labels: {
			servicesForSeafarers: 'Services for Seafarer',
			openVacancies: 'Open Vacancies',
			openApplication: 'Open Application',
			jobTitleCard: 'Job title:',
			rankCard: 'Rank:',
			salaryCard: 'Salary:',
			salaryDetailsCard: 'Salary details:',
			joiningDateCard: 'Joining date:',
			rotationCard: 'Rotation:',
			vesseltype: 'Vessel type: ',
			additionalInformation: 'Additional information: ',
			jobRequirements: 'Job requirements: ',
			vesselInformation: 'Vessel information: ',
			pleaseEnterEmail: 'Please enter your E-mail address',
			acceptTos: 'I hereby accept ',
			dragdropMultiple: 'Drag and drop files here',
			dragdropSingle: 'Drag and drop file here',
			uploadInProgress: 'Upload in progress...',
			languages: 'Languages',
			newLanguage: 'New language',
			rating: 'Rating',
			level: 'Level',
			education: 'Education',
			seaServiceWithOtherCompanies: 'SEA SERVICE - Experience with other companies',
			newSeaExperienceWithOtherCompanies: 'New sea experience with other companies',
			newEducation: 'New education',
			documents: 'Documents',
			validity: 'VALIDITY',
			newDocument: 'New document',
		},
		modules: {
			login: 'Login',
			showcase: 'Showcase',
			openApplication: 'Open Application',
			vacancyApplication: 'Vacancy Application',
		},
		fields: {
			name: 'Name',
			surname: 'Surname',
			phone: 'Phone',
			nationality: 'Nationality',
			rank: 'Rank',
			notes: 'Notes',
			seamanBook: "Seaman's Book Number",
			vesselExp: 'Vessel Experience',
			email: 'E-mail',
			seconds: 'seconds',
			cv: 'CV',
			availableDate: 'Available date',
			dateOfBirth: 'Date of birth',
			nationalIdentifierOib: 'National identifier (OIB if Croatian)',
			countryOfResidency: 'Country of residency',
			placeOfBirth: 'Place of birth',
			gender: 'Gender',
			maritalStatus: 'Marital status',
			accountCurrency: 'Account currency',
			streetNameAndNumber: 'Street name and number',
			city: 'City',
			postCode: 'Post code',
			country: 'Country',
			airport: 'Closest int. airport',
			emergencyContactName: 'NEXT OF KIN - name and surname',
			emergencyContactRelationship: 'NEXT OF KIN - relationship',
			emergencyContactStreetNameAndNumber: 'NEXT OF KIN - street name and number',
			emergencyContactCity: 'NEXT OF KIN - city',
			emergencyContactPostCode: 'NEXT OF KIN - post code',
			emergencyContactCountry: 'NEXT OF KIN - country',
			emergencyContactNumber: 'NEXT OF KIN - contact number',
			emergencyContactEmail: 'NEXT OF KIN - contact email',
			language: 'Language',
			rating: 'Rating',
			level: 'Level',
			noProfficiency: 'No profficiency',
			poor: 'Poor',
			good: 'Good',
			fluent: 'Fluent',
			schoolName: 'School name',
			from: 'From',
			to: 'To',
			companyName: 'Company name',
			vessel: 'Vessel',
			signedOn: 'Signed on',
			signedOff: 'Signed off',
			duration: 'Duration',
			typeOfVessel: 'Vessel type',
			dwt: 'Dwt',
			gt: 'Gt',
			engineType: 'Engine type',
			kW: 'kW',
			dpManufacturer: 'Dp manufacturer',
			dpType: 'Dp type',
			type: 'Type',
			documentType: 'Document type',
			issuingCountry: 'Issuing country',
			issuedBy: 'Issued by',
			documentNumber: 'Document number',
			dateIssued: 'Date issued',
			dateOfExpiry: 'Date of expiry',
			documentName: 'Document name',
		},
		alerts: {
			deletionQuestion: 'Are you sure you want to delete this record?',
			fileDeletionQuestion: 'Are you sure you want to delete this file?',
			basicUpdate: 'Changes saved.',
			basicDelete: 'Record deleted.',
			basicAdd: 'New record created.',
			basicError: 'An error occurred on the server.',
			fieldMissing: 'This field is required.',
			cvFileMissing: 'Please attach your CV file to the application.',
			leaveQuestion: 'Are you sure you want to exit without saving?',
			linkExpired: 'Link expiration date is ended. Please apply for a vacancy or an open application again.',
			lengthError: 'Field %field% can contain max %length% characters.',
			invalidFileType: 'Invalid file type. Only PDF and image files are allowed.',
			uploadCountLimit:
				'You exceeded file upload limit. Please apply for a vacancy or an open application again.',
			alreadySubmitted: 'Application is already submitted with this link.',
			oibFormattFailed: 'OIB is not valid.',
			availableDateOlderThanNow: 'Available date must be newer than today!',
			dateOfBirthDateOlder: "Date of birth must be older than today's date!",
			languageAlreadyAdded: 'This language is already added!',
			selectLevel: 'Select level!',
			uploadFile: 'Upload file',
			shortFormVerify:
				'You will send your short application. If you wish to expedite your application process, please fill our full application prior to clicking the submit button.',
			fillOutRequiredFields: 'You must fill in all required fields before submitting your application',
			shortFormExistingVerify:
				"Welcome Back! <br> It looks like you've applied with us before because we have your data in our system. We'll be using your existing details for this application. <br> If you need to update or add any information, please use the ''Note'' field or contact us directly at" +
				'<a href="mailto:info@azara.hr"> info@azara.hr </a>',
		},
		buttons: {
			backToWebsite: 'Back to website',
			openApplication: 'Open Application',
			loadMore: 'Load more',
			moreDetails: 'More details',
			lessDetails: 'Less details',
			apply: 'Apply',
			submit: 'Submit',
			save: 'Save',
			cancel: 'Cancel',
			ok: 'OK',
			yes: 'Yes',
			no: 'No',
			fillOutFullApplication: 'Fill out full application',
			fillOutOnlyRequiredFields: 'Fill out only required fields',
			addLanguage: 'Add language',
			delete: 'Delete',
			addEducation: 'Add education',
			addSeaService: 'Add sea service',
			removeSeaService: 'Remove service',
			addDocument: 'Add document',
			removeDocument: 'Remove document',
			filOutFullApplication: 'Fill out the full application',
			submitShortApplication: 'Submit short application',
			submitFullApplication: 'Submit full application',
			applyForThisJob: 'Apply for this job',
		},
		tooltips: {
			filter: 'Filter',
			logout: 'Logout',
		},
		texts: {
			vacanciesText:
				'Here you can find a list of current job vacancies. If there is no current vacancy that interests you, please register with us and we will inform you as soon as such vacancy occurs.',
			emailVerfificationSuccessMessage:
				"A message with further instructions has been sent to your e-mail address. Please check your mailbox. If you don't receive an e-mail, please contact us on info@azara.hr",
			defaultApplicationText: 'Please enter your details below',
			openApplicationExistingSeafarerText:
				'Your email address is already in our database. Please check the information below and let us know if there are any changes to your contact information or rank.',
			submitSuccesText: 'You have successfully submited your application. We sent you confirmation e-mail.',
			redirectingText: 'Redirecting to azara.hr in',
			applicationFor: 'Application for',
			openApplicationDescription:
				"Didn't find any suitable position? We're always looking for talented people to work with us. Don't hesitate to send your application by clicking the ",
			openApplicationLink: 'open application link.',
			openApplicationDescription2:
				"Before starting the process, please prepare your main documents and CV form. If you don't hava a CV form, you can download a blank one using the ",
			link: 'link.',
			vacancyDescription: 'Here is a list of current job vacancies. After you identify the vacancy of interest, ',
			followInstructions: 'please follow the instructions closely.',
			vacancyDescription2:
				'The process will take only a few moments for applicants already in our database. For those applying for the first time with us, we request only basic information relevant to your future employment with us.',
		},
	};
}
